import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import style from './mobileNav.module.scss';

export default function MobileNav({ isOpen, closeDrawer}) {
  const location = useLocation();

  const handleClick = () => {
    closeDrawer();
  }

  const portfolioActive = location.pathname === '/portfolio';
  const aboutActive = location.pathname === '/about';
  const resumeActive = location.pathname === '/resume';

  const navClass = (active) => (active ? `${style.navLink} ${style.navLinkActive}` : style.navLink);

  return (
    <nav className={`${style.mobileNav} ${!isOpen ? style.show : ""}`} aria-label="Main">
      <ul className={style.navUL}>
        <li className={style.headerLI}><Link onClick={handleClick} to="/portfolio" className={navClass(portfolioActive)}>Portfolio</Link></li>
        <li className={style.headerLI}><Link onClick={handleClick} to="/about" className={navClass(aboutActive)}>About</Link></li>
        <li className={style.headerLI}><Link onClick={handleClick} to="/resume" className={navClass(resumeActive)}>Résumé</Link></li>
      </ul>
    </nav>
  )
}
